// Course program data extracted from the official Preliminary Program PDF (WBA_Program_ENG_3007).
export const COURSE_INFO = {
  president: "Dr. Marco Stella — Director of Emergency Surgery Division",
  directors: [
    "Dr. Federico Fiori — Head of the Abdominal Wall Surgery Unit, San Carlo Borromeo Hospital",
    "Prof. Giampaolo Formisano — Head of the Minimally Invasive and Robotic Surgery Unit, San Paolo Hospital",
  ],
  committee: ["Dr. Carlo Corbellini", "Dr. Domenico Lo Conte", "Dr. Lorenzo Gallitiello", "Dr. Asia Lodolini"],
  patrons: [
    "Italian Society of Hernia and Abdominal Wall Surgery",
    "SICE — Società Italiana di Chirurgia Endoscopica e Nuove Tecnologie",
    "Italian Chapter SIC — Society of Surgery",
  ],
  organized_by: "Organized by Federico Fiori MD — Head of Abdominal Wall Surgery Unit, ASST Santi Paolo e Carlo — Milano",
  venue: "Conference Room — San Carlo Borromeo Hospital, Via Pio II 3, 20153 Milan (MI)",
  secretariat: "Ti.Gi. Meeting & Congressi · Via Udine 12, 58100 Grosseto · +39 0564 412038 · giusi@tigicongress.com",
  fees: [
    { label: "1 focus session", price: "€180" },
    { label: "2 focus sessions", price: "€250" },
    { label: "3 focus sessions", price: "€300" },
    { label: "Residents (all 3 sessions)", price: "€150" },
  ],
  includes: [
    "Access to scientific and practical sessions of the selected focus area(s)",
    "Live surgery sessions, video relive and clinical case discussions",
    "Educational materials and scientific contents",
    "Catering services in the program",
    "Course dinner on the first day of each focus session",
    "Certificate of attendance",
  ],
};

export const STEPS = [
  {
    n: "01",
    focus: "Diastasis — Open vs. Minimally Invasive Surgery",
    dates: "September 23–24, 2026",
    sessions: [
      { t: "Topic Introduction: The Diastasis Problem", s: "Nereo Vettoretto" },
      { t: "Pathophysiology and Clinical Aspects", s: "Alessandro Carrara" },
      { t: "Physical Therapy", s: "Letizia Greco" },
      { t: "Borderline Surgery, Abdominoplasty, MILA & Ancillary Procedures", s: "Federico Fiori" },
      { t: "Devices for Surgical Soft Tissue Remodeling", s: "Domenico Ventura" },
      { t: "Diastasis through the Eyes of the Plastic Surgeon", s: "Daniele Bollero" },
      { t: "My Choices in Diastasis Repair", s: "David Ross" },
      { t: "Minimally Invasive Surgical Techniques for Diastasis", s: "Federico Fiori" },
      { t: "My MIS Diastasis Algorithm & Avoiding Complications", s: "Rodrigo Galhego" },
      { t: "The Use of Staplers", s: "Enrico Lauro" },
      { t: "THT Relive", s: "Alessandro Carrara" },
      { t: "Misar Relive", s: "Gabriele Manetti" },
      { t: "TESAR", s: "Federico Fiori" },
      { t: "WALL ARENA: Debating Techniques", s: "Faculty" },
      { t: "Live Surgery: Open Laparoabdominoplasty with Mesh + TESAR", s: "Federico Fiori" },
    ],
  },
  {
    n: "02",
    focus: "Minimally Invasive Retromuscular & Component Separation",
    dates: "November 24–25, 2026",
    sessions: [
      { t: "From Rives-Stoppa to MIS: Surgical Anatomy of the Abdominal Wall", s: "Cesare Stabilini" },
      { t: "Meshes: Which Ones and When", s: "Lorenzo Morini" },
      { t: "Posterior Approaches: TARUP, eTEP, Carolinas Crossover, MILOS", s: "Federico Fiori" },
      { t: "Relive: TARUP", s: "Giampaolo Formisano" },
      { t: "ACS — Anterior Component Separation", s: "Federico Fiori" },
      { t: "TAR: Anatomy and Techniques", s: "Giampaolo Formisano" },
      { t: "Flank Hernia: Definition of the Problem", s: "Cesare Stabilini" },
      { t: "Clinical Cases and Video Discussion", s: "Cavallaro · Fiori · Formisano · Morini" },
      { t: "MIS CAWR — The Limit", s: "Conrad Ballecer" },
      { t: "The Master Talk: Adverse Events in eTEP", s: "Ramana Balasubramanian" },
      { t: "Live Surgery: reTEP (San Carlo) & rTAR (San Paolo)", s: "Fiori · Formisano" },
    ],
  },
  {
    n: "03",
    focus: "Intraperitoneal / Preperitoneal and VFT Approaches",
    dates: "January 20–21, 2027",
    sessions: [
      { t: "Intraperitoneal Techniques: Rationale, Results, Complications", s: "Sofia Esposito" },
      { t: "IPOM Plus (Step-by-step video)", s: "Giorgio Soliani" },
      { t: "LIRA (Step-by-step video)", s: "Davide Cavaliere" },
      { t: "Preperitoneal: Ventral TAPP", s: "Giampaolo Formisano" },
      { t: "Preperitoneal: PeTEP & Cranial PeTEP", s: "Federico Fiori" },
      { t: "PeTEP: My Tips and Tricks", s: "Hector Valenzuela" },
      { t: "LOD: Loss of Domain — Issues, Techniques, Complications", s: "Camillo Leonardo Bertoglio" },
      { t: "Botox", s: "Nicola Cangiano" },
      { t: "PPP", s: "Carlo Corbellini" },
      { t: "Fasciotens", s: "Gereon Lill" },
      { t: "VAC Therapy", s: "Annalisa Gagliano" },
      { t: "Live Surgery: Laparoplasty with Fasciotens & rPeTEP / Ventral TAPP", s: "Fiori · Formisano" },
      { t: "Gracilis Muscle Transposition: Rationale and Relive", s: "Carrara · Fiori" },
    ],
  },
];

export const FACULTY = [
  "Marco Stella", "Federico Fiori", "Giampaolo Formisano", "Pietro Paolo Bianchi", "Stefano Schieppati",
  "Nereo Vettoretto", "Alessandro Carrara", "Letizia Greco", "Daniele Bollero", "David Ross",
  "Domenico Ventura", "Enrico Lauro", "Gabriele Manetti", "Rodrigo Galhego", "Marta Cavalli",
  "Marco Confalonieri", "Sofia Esposito", "Antonio La Terra", "Luigi Boccia", "Giuseppe Cavallaro",
  "Lorenzo Morini", "Cesare Stabilini", "Gloria Goi", "Jacopo Andreuccetti", "Conrad Ballecer",
  "Ramana Balasubramanian", "Hector Valenzuela", "Bruno Alampi", "Davide Cavaliere", "Giorgio Soliani",
  "Camillo Leonardo Bertoglio", "Michele Carlucci", "Nicola Cangiano", "Carlo Corbellini", "Gereon Lill",
  "Fabrizio Sammartano", "Annalisa Gagliano", "Alberto Di Leo", "Vincenzo Trapani", "Carmelo Magistro",
  "Domenico Lo Conte", "Lorenzo Gallitiello", "Asia Lodolini",
];
